// extracted by mini-css-extract-plugin
export default {"wrapper":"separator_wrapper__63LC3"};